import { Navigate } from 'react-router-dom';
import { MODULE_HUB_PATH } from '@/constants/authRoutes';
import { useWorkspaceModule } from '@/hooks/useWorkspaceModule';
import { BillingSubscriptionsPage } from '@/pages/org/BillingSubscriptionsPage';

export function ModuleWorkspaceSubscriptionPage() {
  const { module, ready } = useWorkspaceModule();

  if (!ready || !module) {
    return <Navigate to={MODULE_HUB_PATH} replace />;
  }

  return <BillingSubscriptionsPage focusModule={module} />;
}
